<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="d-flex mb-5">
    <button class="btn btn-info ml-auto btn-size-normal" [routerLink]="['./', 'add-policies']">
        <span class="btn-inner--text" i18n>Attach Policy</span>
    </button>
</div>
<ngx-datatable [rows]="policies" columnMode="flex" [rowHeight]="48">
    <ngx-datatable-column *ngFor="let col of columns; trackBy: trackColumns"
        [name]="col.name"
        [prop]="col.prop"
        [cellClass]="col.cellClass"
        [headerClass]="col.headerClass"
        [flexGrow]="col.flexGrow">
    </ngx-datatable-column>
    <ngx-datatable-column name="Action" sortable="false" prop="id" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button i18n type="button" class="btn btn-link p-0 m-0" (click)="onRemoveRow(row)"><img alt="Remove From Role" title="Remove From Role" class="row-icon" src="assets/_ionicons_svg_md-trash.svg"></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-policies-table/role-policies-table.component.html